import React, { useEffect, useRef, useState, useMemo } from "react";
import Styled from "styled-components";
import {
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Tooltip,
  Badge,
  Avatar,
  Modal,
  DatePicker,
} from "antd";
import { ShipmentType, TripTypeEnum } from "../../Common/constant";
import UIModal from "../../Reusablecomponents/UIModal";
import ChatComponent from "../../Reusablecomponents/Comment/ChatComponent";
import { ReactComponent as UnResolved } from "../../assets/images/Unresolved.svg";
import { ReactComponent as Resolve } from "../../assets/images/ButtonResolve.svg";
import { ReactComponent as Chat } from "../../assets/images/Chat.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { convertUTCToLocal } from "../../utils/helper";
import filtericon from "../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import { useDispatch, useSelector } from "react-redux";
import { CALL_API } from "../../Common/api";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
const Wrappercontainer = Styled.div`

  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .kpireport_select_filter {
    width: 290px !important;
    height: 34px;
  }
  p {
    padding: 10px 4px 10px 4px;
    margin: 4px 0px 4px 0px;
    font-size: 18px;
    font-weight: 400;
    color: black;
  }
  .kpialerts {
    color: rgb(228, 164, 0);
  }
  .Resolved {
    color: green;
  }
  .UnResolved {
    color: red;
  }
  .customizable_container {
    width: 30%;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .container_two_fordropdown {
    background-color: white;
    margin-top: 25px;
    border-radius: 12px;
    padding: 25px 0px 25px 0px;
  }
  .container_for_header {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 07px 0px;
  }
  .flilter_five {
    margin: 0px;
  }
  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
  .ant-select-selector {
    border-radius: 18px;
  }
  .filterbtn {
    width: 45px;
    height: 42px;
    borderradius: 50%;
    border: 1px solid rgb(237, 237, 241);
    backgroundcolor: rgb(235, 247, 237);
  }
  .filterstyle {
    height: 20px;
    width: 20px;
  }
  .Iconbg {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #ebf7ed;
  }
  .text-wrap {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    line-height: 1.4;
  }
  .chat-box {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .chat-message {
    background-color: #e5efff;
    border-radius: 12px;
    padding: 10px 14px;
    max-width: 75%;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .chat-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
  }

  .chat-meta {
    font-size: 11px;
    color: #666;
    display: flex;
    justify-content: flex-start;
    gap: 6px;
  }

  .chat-sender {
    font-weight: 600;
  }

  .chat-time {
    font-style: italic;
  }
  .compact-col {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 150px;
    max-width: 180px;
    transition: max-width 0.2s ease;
  }

  .compact-col.expanded {
    justify-content: flex-start;
    max-width: 250px; /* only expand a little on hover */
  }
`;
const Styledashboard = Styled.div`
@media (min-width: 320px) and (max-width: 480px) {
  .kpialerts{
      font-size: 12px!important;
   padding:4px 54px 4px 54px;

  } 
.Resolved { font-size: 12px!important;
}.UnResolved {
 font-size: 9px!important;
   padding:4px 54px 4px 54px;

 overflow:hidden;
   padding:4px 54px 4px 54px;
  }.header-container {
    display: flex;
    justify-content: space-between;
    align-items: start!important;
    width: 100%;
    flex-direction: column;}

}
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
font-size: 16px;
font-weight: 400;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .kpialerts {
    color: rgb(228, 164, 0);
    font-size: 16px;
    font-weight: 500;
  }
  .Resolved {
    color: green;
    font-size: 16px;
    font-weight: 500;
  }
  .UnResolved {
    color: red;
    font-size: 16px;
    font-weight: 500;
  }
    .values {
    color: #363636;
    font-size: 32px;
    font-weight: 600;
}
  .customizable_container {
    width: 30%;
    height: 139px;
    background-color: white;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centers content vertically */
    text-align: center; /* Centers text horizontally */
    margin-bottom: 20px;
    border-radius: 12px;
    box-shadow: 2px 2px 5px rgb(232, 235, 240), 5px 5px 10px rgb(232, 235, 240),
      5px 5px 10px rgb(232, 235, 240);
  }
  .customizable_container_forkpi {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
    
  `;
const KpiReports = () => {
  const [filterCount, setFilterCount] = useState(0);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterform] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [kpiChart, setKPIChart] = useState([]);
  const [kpiTable, setKPITable] = useState([]);

  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CONT_KRPT", "EX"),
    [reduxPermissions],
  );
  const resolveAllowed = useMemo(
    () => hasPermission("CONT_KRPT", "RES"),
    [reduxPermissions],
  );
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState([null, null]);

  const [filterValues, setFilterValues] = useState({
    name: "",
    vehicleno: "",
    consignor: "",
    transporter: "",
    shipment: "",
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
    consignee: "",
    consigncode: "",
    status: "",
  });

  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [modalType, setModalType] = useState(null); // "view" or "resolve"
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [commentsList, setCommentsList] = useState([]);
  const [Hoveredrow, setHoveredRow] = useState(null);
  const [resolveModal, setResolveModal] = useState(false);

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const handlemouseenter = (key) => {
    setHoveredRow(key);
  };

  const handlemouseleave = () => {
    setHoveredRow(null);
  };

  const getKPICharts = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getkpiReportData?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate?.[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
          "YYYY-MM-DD",
        )}&page=${currentPage}&PageSize=${pageSize}`,
        {
          code: filterValues?.consigncode || 0,
          RecName: filterValues?.consignee || "",
          CustName: filterValues?.consignor || "",
          Transporter: filterValues?.transporter || "",
          Name: filterValues?.name || "",
          REGNO: filterValues?.vehicleno || "",
          Status: filterValues?.status || "",
          ConsignId: "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setLoading(false);
      setKPIChart(data);
    } catch (error) {
      console.error("[getKPICharts] error -->", error);
    }
  };

  const getKPITable = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getKPIPagination?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate?.[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
          "YYYY-MM-DD",
        )}&page=${currentPage}&PageSize=${pageSize}`,
        {
          code: filterValues?.consigncode || 0,
          RecName: filterValues?.consignee || "",
          CustName: filterValues?.consignor || "",
          Transporter: filterValues?.transporter || "",
          Name: filterValues?.name || "",
          REGNO: filterValues?.vehicleno || "",
          Status: filterValues?.status || "",
          ConsignId: "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setLoading(false);
      setKPITable(data?.KPIAlertTable);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("[getKPITable] error -->", error);
    }
  };
  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getcommentTab`, {
      refTab: "KPI",
      refId: 389114,
    });
    setCommentsList(data);
    setLoading(false);
  };
  const handleBulkResolve = async (records = []) => {
    try {
      const payload = {
        uid: userInfo?.UID,
        mcid: userInfo?.MCID,
      };
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "contReport/KPIbulkResolve",
        payload,
      );
      if (ResponseCode === 200) {
        message.success("KPIs resolved in bulk successfully!");
        setResolveModal(false);
        getKPICharts();
        getKPITable();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPIs.");
    } finally {
      setLoading(false);
    }
  };
  const handleResolve = async () => {
    try {
      if (!selectedRecord?.ID) {
        message.error("No KPI selected.");
        return;
      }
      const payload = {
        ID: selectedRecord.ID,
        MESSAGE: selectedRecord.resolutionComment || "",
        RESOLVEDBY: userInfo?.UID,
      };
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "contReport/KPIResolve",
        payload,
      );
      if (ResponseCode === 200) {
        message.success(data?.data || "KPI resolved successfully!");
        setResolveModal(false);
        setModalType("");
        getKPICharts();
        getKPITable();
      }
    } catch (error) {
      console.error("Error resolving KPI:", error);
      message.error("An error occurred while resolving the KPI.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getKPICharts();
    }
  }, [filterValues, selectedDate]);
  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getKPITable();
    }
  }, [filterValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const handleresolveclose = () => {
    setResolveModal(false);
    setModalType("");
    setSelectedRecord(null);
    setModalType(null);
  };
  const handleChatClick = (record) => {
    setModalType("view"); // show resolved chat
    setSelectedRecord(record);
    setResolveModal(true);
    getCommentData(record); // pass record or ID to fetch
  };

  const handleresolveopen = (record) => {
    setModalType("resolve"); // show textarea to resolve
    setSelectedRecord({ ...record, resolutionComment: "" }); // ensure comment is tracked
    setResolveModal(true);
    getCommentData(record); // same here
  };

  const formattedTime = (minutes) => {
    return dayjs().startOf("day").add(minutes, "minute").format("HH:mm");
  };
  const formattedDifferentTime = (totalMinutes) => {
    if (totalMinutes == null || isNaN(totalMinutes)) {
      return "00:00:00";
    }

    const absMinutes = Math.abs(totalMinutes);

    const days = Math.floor(absMinutes / (24 * 60));
    const remainingMinutes = absMinutes % (24 * 60);

    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;

    return `${days.toString().padStart(2, "0")}:${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  };

  const unresolvedKPIs = kpiTable?.filter((item) => !item.RESOLVEDBY);

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle special case: status field (based on RESOLVEDBY)
      if (tableSort.field === "status") {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        const result = Number(aResolved) - Number(bResolved);
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle numeric fields
      if (
        ["MAXMINUTES", "DURATION", "MINMINUTES", "RESOLVEDBY"].includes(
          tableSort.field,
        )
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };

  const columns1 = [
    {
      title: "Date & Time",
      dataIndex: "CRON",
      key: "CRON",
      sorter: (a, b) => (a.CRON || "").localeCompare(b.CRON || ""),
      sortOrder: tableSort.field === "CRON" ? tableSort.order : null,
      render: (_, record) => (
        <span>{convertUTCToLocal(record?.CRON)}</span>
      )
    },
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => (a.Code || "").localeCompare(b.Code || ""),
      sortOrder: tableSort.field === "Code" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "RecName",
      key: "RecName",
      sorter: (a, b) => (a.RecName || "").localeCompare(b.RecName || ""),
      sortOrder: tableSort.field === "RecName" ? tableSort.order : null,
    },
    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
      sorter: (a, b) => (a.CustName || "").localeCompare(b.CustName || ""),
      sortOrder: tableSort.field === "CustName" ? tableSort.order : null,
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
      sorter: (a, b) =>
        (a.Transporter || "").localeCompare(b.Transporter || ""),
      sortOrder: tableSort.field === "Transporter" ? tableSort.order : null,
    },
    {
      title: "KPI Name",
      dataIndex: "NAME",
      key: "NAME",
      sorter: (a, b) => (a.NAME || "").localeCompare(b.NAME || ""),
      sortOrder: tableSort.field === "NAME" ? tableSort.order : null,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => {
        const aResolved = a.RESOLVEDBY != null;
        const bResolved = b.RESOLVEDBY != null;
        return Number(aResolved) - Number(bResolved);
      },
      sortOrder: tableSort.field === "status" ? tableSort.order : null,
      render: (_, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const statusText = isResolved ? "Resolved" : "Unresolved";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {!isResolved && <UnResolved />} {statusText}
          </div>
        );
      },
    },
    {
      title: "Target Duration",
      dataIndex: "MAXMINUTES",
      key: "MAXMINUTES",
      sorter: (a, b) => (a.MAXMINUTES || 0) - (b.MAXMINUTES || 0),
      sortOrder: tableSort.field === "MAXMINUTES" ? tableSort.order : null,
      render: (MAXMINUTES) => {
        return formattedTime(MAXMINUTES);
      },
    },
    {
      title: "Actual Duration",
      dataIndex: "DURATION",
      key: "DURATION",
      sorter: (a, b) => (a.DURATION || 0) - (b.DURATION || 0),
      sortOrder: tableSort.field === "DURATION" ? tableSort.order : null,
      render: (DURATION) => {
        return formattedTime(DURATION);
      },
    },
    {
      title: "Difference",
      dataIndex: "MINMINUTES",
      key: "MINMINUTES",
      sorter: (a, b) => (a.MINMINUTES || 0) - (b.MINMINUTES || 0),
      sortOrder: tableSort.field === "MINMINUTES" ? tableSort.order : null,
      render: (text) => (
        <div style={{ textAlign: "center", lineHeight: 1.5 }}>
          <div>{formattedDifferentTime(text)}</div>
          <div style={{ fontSize: "14px", color: "#888" }}>DD:HH:MM</div>
        </div>
      ),
    },
    {
      title: "Resolved by",
      dataIndex: "RESOLVEDBYNAME",
      key: "RESOLVEDBYNAME",
      sorter: (a, b) =>
        (a.RESOLVEDBYNAME || "").localeCompare(b.RESOLVEDBYNAME || ""),
      sortOrder: tableSort.field === "RESOLVEDBYNAME" ? tableSort.order : null,
      render: (text) => <div className="text-wrap">{text || "-"}</div>,
    },
    {
      title: "Message",
      dataIndex: "MESSAGE",
      key: "MESSAGE",
      sorter: (a, b) => (a.MESSAGE || "").localeCompare(b.MESSAGE || ""),
      sortOrder: tableSort.field === "MESSAGE" ? tableSort.order : null,
      render: (text) => <div>{text || "-"}</div>,
    },
    {
      title: "",
      dataIndex: "x",
      key: "x",
      width: 120, // optional fixed width
      render: (text, record) => {
        const isResolved =
          record.RESOLVEDBY !== null && record.RESOLVEDBY !== undefined;
        const isHovered = Hoveredrow === record.key;

        return (
          <div className={`compact-col ${isHovered ? "expanded" : ""}`}>
            {!isHovered ? (
              <span>{text || "-"}</span>
            ) : (
              <>
                <Chat
                  className="cursor-pointer"
                  onClick={() => handleChatClick(record)}
                  style={{ fontSize: 18, cursor: "pointer" }}
                />
                {!isResolved && (
                  <Resolve
                    onClick={() => {
                      if (!resolveAllowed) return;
                      handleresolveopen(record);
                    }}
                    style={{
                      cursor: resolveAllowed ? "pointer" : "not-allowed",
                    }}
                  />
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];
  //export functionality for trip time reprt tabel
  const prepareCSV = async (event, done, page = 1, pageSize = 10) => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `/contReport/getKPIPagination?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&page=1&PageSize=${total}`,
        {
          code: filterValues?.consigncode || 0,
          RecName: filterValues?.consignee || "",
          CustName: filterValues?.consignor || "",
          Transporter: filterValues?.transporter || "",
          Name: filterValues?.name || "",
          REGNO: filterValues?.vehicleno || "",
          Status: filterValues?.status || "",
          ConsignId: "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );

      if (data?.KPIAlertTable.length > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.KPIAlertTable);

        const csvData = (sortedData || []).map((item) => ({
          "Date & Time": item.CRON ? convertUTCToLocal(item.CRON) : "-",
          "Consign Code": item.Code || "",
          Consignee: item.RecName || "-",
          Consignor: item.CustName || "-",
          Transporter: item.Transporter || "-",
          "KPI Name": item.NAME || "",
          Status:
            item.status !== null &&
            item.status !== undefined &&
            item.status !== ""
              ? "Unresolved"
              : "Resolved",
          Duration: formattedTime(item.DURATION) || "",
          "Actual Duration": formattedTime(item.DURATION) || "",
          "Target Duration": formattedTime(item.MAXMINUTES) || "",
          Difference: formattedDifferentTime(item.MINMINUTES) || "",
          "Resolved On": item.RESOLVEDON
            ? dayjs(item.RESOLVEDON).format("DD/MM/YYYY HH:mm:ss")
            : "-",
          "Resolved By": item.RESOLVEDBYNAME || "",
          Message: item.MESSAGE || "",
        }));
        setCSVList(csvData && csvData.length > 0 ? csvData : []);

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };
  const handleDurationChange = (value) => {
    let startDate = null;
    let endDate = null;

    switch (value) {
      case "today":
        startDate = dayjs();
        endDate = dayjs();
        break;
      case "current_month":
        startDate = dayjs().startOf("month");
        endDate = dayjs().endOf("month");
        break;
      case "last_month":
        startDate = dayjs().subtract(1, "month").startOf("month");
        endDate = dayjs().subtract(1, "month").endOf("month");
        break;
      case "current_year":
        startDate = dayjs().startOf("year");
        endDate = dayjs().endOf("year");
        break;
      default:
        break;
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]); // keep state in sync
      filterform.setFieldsValue({
        duration: value,
        daterange: [startDate, endDate],
      });
    }
  };

  return (
    <Styledashboard>
      <Row>
        <Col xl={24} sm={24}>
          <Spin spinning={loading}>
            <div>
              <div className="customizable_container_forkpi">
                <div className="customizable_container">
                  <p className="kpialerts">KPI Alerts</p>
                  <p className="values">
                    {kpiChart?.KPIAlert?.[0]?.Total || 0}
                  </p>
                </div>
                <div className="customizable_container">
                  <p className="Resolved">Resolved</p>
                  <p className="values">
                    {kpiChart?.KPIAlert?.[0]?.Resolved || 0}
                  </p>
                </div>
                <div className="customizable_container">
                  <p className="UnResolved">UnResolved</p>
                  <p className="values">
                    {kpiChart?.KPIAlert?.[0]?.Unresolved || 0}
                  </p>
                </div>
              </div>
            </div>
          </Spin>
        </Col>
      </Row>
      <div className="header-container">
        <div className="head">{total} KPI Alerts</div>
        <div
          style={{
            display: "flex", // Use Flexbox for alignment
            alignItems: "center", // Vertically align items
            justifyContent: "flex-end", // Align items to the right
            gap: "10px", // Add spacing between the icons
          }}
        >
          <div>
            <Badge count={filterCount} onClick={() => setFilterModalOpen(true)}>
              <Avatar shape="circle" size="small" src={filtericon} />
            </Badge>
          </div>
          <Spin spinning={CSVLoader}>
            <Tooltip title={!exportAllowed ? "No permission" : ""}>
              <img
                src={ExportIcon}
                alt="Upload Icon"
                style={{
                  cursor: exportAllowed ? "pointer" : "not-allowed",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  if (!exportAllowed) return;
                  prepareCSV();
                }}
              />
            </Tooltip>
          </Spin>
          <CSVLink
            data={CSVList}
            filename={"KPI Report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
          <Tooltip title={!resolveAllowed ? "No permission" : ""}>
            <ButtonFilled
              style={{
                cursor: resolveAllowed ? "pointer" : "not-allowed",
              }}
              loading={loading}
              onClick={() => {
                if (!resolveAllowed) return;
                handleBulkResolve(unresolvedKPIs);
              }}
            >
              Resolve All
            </ButtonFilled>
          </Tooltip>
        </div>
      </div>
      <br />
      <div>
        <Spin spinning={loading}>
          {kpiTable.length > 0 && (
            <StyledTable
              dataSource={kpiTable}
              columns={columns1}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
              onRow={(record, index) => ({
                onMouseEnter: () => {
                  handlemouseenter(record?.key);
                },
                onMouseLeave: () => {
                  handlemouseleave();
                },
              })}
            />
          )}
        </Spin>
      </div>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              setFilterValues({ userid: "", username: "", email: "" }); // Reset the state
              filterform?.setFieldsValue({
                name: "",
                vehicleno: "",
                consignor: "",
                transporter: "",
                shipment: "",
                duration: "",
                daterange: "",
                consignee: "",
                consigncode: "",
                status: "",
              });
              setFilterCount(0);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
            </div>
          </Col>
        </Row>

        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            const count = Object.values(allvalues).filter(
              (val) =>
                val !== undefined &&
                (val !== null) & 1 & (String(val).trim() !== ""),
            ).length;

            setFilterCount(count);
            setFilterValues(allvalues);
          }}
          initialValues={filterValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="KPI Name" name="name">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="consignor">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="transporter">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                />{" "}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Shipment Type" name="shipment">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={ShipmentType?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Duration" name="duration">
                <Select onChange={handleDurationChange}>
                  {Duration?.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item?.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Date Range" name="daterange">
                <RangePicker
                  onChange={(dates) => {
                    if (dates && dates[0] && dates[1]) {
                      setDuration(""); // Clear duration if user picks a custom date
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consign Code" name="consigncode">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Status" name="status">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle No." name="vehicleno">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={vehicleList?.map((item) => ({
                    label: item.REGNO,
                    value: item.VEHID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <UIModal
        width={600}
        open={resolveModal}
        onClose={handleresolveclose}
        closeButton={false}
        header={
          <Wrappercontainer>
            <Spin spinning={loading}>
              <Row>
                <Col xl={24} sm={24}>
                  <div className="modal_container_forfiltermenu">
                    <h4 className="flilter_five">
                      {modalType === "view" ? "Comments" : "Resolving KPI"}
                    </h4>
                  </div>
                  <hr />
                </Col>

                <Col xl={24} sm={24}>
                  {modalType === "view" ? (
                    <div>
                      <ChatComponent
                        data={commentsList}
                        user={userInfo?.UID}
                        getData={getCommentData}
                        id={389114}
                        RefTab="KPI"
                        setLoading={setLoading}
                      />
                    </div>
                  ) : (
                    <>
                      <strong>Comments</strong>
                      <br />
                      <Input.TextArea
                        placeholder="Enter resolution comments"
                        rows={4}
                        value={selectedRecord?.resolutionComment}
                        onChange={(e) =>
                          setSelectedRecord((prev) => ({
                            ...prev,
                            resolutionComment: e.target.value,
                          }))
                        }
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Spin>
          </Wrappercontainer>
        }
        footer={
          modalType === "resolve" ? (
            <Wrappercontainer>
              <div
                key="footer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: "15px",
                }}
              >
                <Buttontransparent
                  className="cancel_btn_forpopup_two"
                  onClick={handleresolveclose}
                >
                  Cancel
                </Buttontransparent>
                <ButtonFilled loading={loading} onClick={() => handleResolve()}>
                  Resolve
                </ButtonFilled>
              </div>
            </Wrappercontainer>
          ) : null
        }
      />
      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        total={total}
        handlePageChange={handlePageChange}
      />
    </Styledashboard>
  );
};

export default KpiReports;
